import { render, staticRenderFns } from "./apkSet.vue?vue&type=template&id=2028bea9&scoped=true"
import script from "./apkSet.vue?vue&type=script&lang=js"
export * from "./apkSet.vue?vue&type=script&lang=js"
import style0 from "./apkSet.vue?vue&type=style&index=0&id=2028bea9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028bea9",
  null
  
)

export default component.exports